'use strict';

(function (root, $, undefined) {
  // store filter for each group
  if ($('.js-filtering').length) {

    // flatten object by concatting values
    var concatValues = function concatValues(obj) {
      var value = '';
      for (var prop in obj) {
        value += obj[prop];
      }
      return value;
    };

    var filters = {};
    Isotope.Item.prototype._create = function () {
      // assign id, used for original-order sorting
      this.id = this.layout.itemGUID++;
      // transition objects
      this._transn = {
        ingProperties: {},
        clean: {},
        onEnd: {}
      };
      this.sortData = {};
    };

    Isotope.Item.prototype.layoutPosition = function () {
      this.emitEvent('layout', [this]);
    };

    Isotope.prototype.arrange = function (opts) {
      // set any options pass
      this.option(opts);
      this._getIsInstant();
      // just filter
      this.filteredItems = this._filter(this.items);
      // flag for initalized
      this._isLayoutInited = true;
    };

    // layout mode that does not position items
    Isotope.LayoutMode.create('none');

    var $grid = $('.js-filter-menu').isotope({
      itemSelector: '.js-page-menu-item',
      layoutMode: 'none'
    });

    // bind filter on select change
    $('.js-filters-select').on('change', function () {
      // get filter value from option value
      var filterValue = this.value;
      var filterGroup = $(this).attr('data-filter-group');
      // use filterFn if matches value
      filters[filterGroup] = filterValue;
      var filterValue = concatValues(filters);
      $grid.isotope({ filter: filterValue });
    });
  }
})(undefined, jQuery);